module.exports = __webpack_public_path__ + "img/img_student4.5a64437b.png";